import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchNextBill = createAsyncThunk(
  'nextBill/fetchNextBill',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/next_bill',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
